import { render } from "./FeiYongFuKuan.vue?vue&type=template&id=1748fe0a"
import script from "./FeiYongFuKuan.vue?vue&type=script&lang=js"
export * from "./FeiYongFuKuan.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__